import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { EcommercePlatform } from '@/interfaces/PluginInterface/PluginInterface';

interface EcommercePlatformData {
  data: EcommercePlatform | undefined;
}

interface EcommercePlatformState {
  data: EcommercePlatformData | null;
}

const initialState: EcommercePlatformState = {
  data: null,
};

export const ecommercePlatformSlice = createSlice({
  name: 'ecommercePlatform',
  initialState,
  reducers: {
    saveEcommercePlatformData: (state, action: PayloadAction<EcommercePlatformData>) => {
      state.data = action.payload;
    },
    clearEcommercePlatformData: (state) => {
      state.data = null;
    },
  },
});

export const { saveEcommercePlatformData, clearEcommercePlatformData } = ecommercePlatformSlice.actions;
